import { useEffect, useState } from 'react';

const REVIEW_STAT_SELECTOR = '.cssVar-subheading__number';

const readReviewStats = () => {
  const reviewStats = document.querySelectorAll(REVIEW_STAT_SELECTOR);
  if (reviewStats.length < 2) return null;

  return {
    average: reviewStats[0].textContent.trim(),
    total: reviewStats[1].textContent.trim(),
  };
};

const useReviewsIoWidgetStats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const updateStats = () => {
      const nextStats = readReviewStats();
      if (!nextStats) return;

      setStats((currentStats) =>
        currentStats?.average === nextStats.average && currentStats?.total === nextStats.total
          ? currentStats
          : nextStats,
      );
    };
    const observer = new MutationObserver(updateStats);

    updateStats();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return stats;
};

export default useReviewsIoWidgetStats;
